/**
 * Cooking Weight Converter - Scroll to result functionality
 * @module CookingWeightConverter
 */
(function() {
    'use strict';

    /**
     * Scroll to conversion result when present
     */
    function scrollToResult() {
        var el = document.getElementById('conversion-result');
        if (el && typeof el.scrollIntoView === 'function') {
            window.requestAnimationFrame(function() {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        }
    }

    /**
     * Initialize the converter functionality
     */
    function init() {
        scrollToResult();
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
